import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="text-lg font-black tracking-tight text-background-50">激情视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汇聚激情题材影视剧与精彩视频内容，涵盖剧情介绍、明星资讯与影视评论，带你发现每一部值得看的作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">内容导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">影视分类</Link></li>
              <li><Link to="/special" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">专题合集</Link></li>
              <li><Link to="/search" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">搜索影片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">关于与帮助</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/about" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/contact" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">联系我们</Link></li>
              <li><Link to="/stars" className="text-background-300 hover:text-primary-300 transition-colors cursor-pointer">明星资讯</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-300" /> hello@passionvideo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-300" /> 400-888-2026
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-300" /> 上海市静安区光影文化产业园
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 激情视频 PASSION VIDEO. 本站内容均为示范展示，仅供学习交流。</p>
          <p className="flex items-center gap-4">
            <span>内容由用户共同分享</span>
            <span className="hidden sm:inline">·</span>
            <span>免责声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}